/** When your routing table is too long, you can split it into small modules**/

import Layout from '@/views/layout/Layout'

const componentsRouter = {
    path: '/lift',
    component: Layout,
    name: 'Lift',
    menuid: 47,
    systemtypeid: 1,
    meta: {
      title: 'LiftTitle',
      icon: 'icon'
    },
    children: [
      {
        path: 'timeslot/index',
        component: () => import('@/views/lift/timeslot/list'),
        name: 'LiftTimeSlotList',
        menuid: 56,
        systemtypeid: 1,
        meta: {title: 'TimeSlotList', icon: 'dashboard'}
      }, 
      {
        path: 'holiday/index',
        component: () => import('@/views/lift/holiday/list'),
        name: 'LiftHolidayList',
        menuid: 36,
        systemtypeid: 1,
        meta: {title: 'HolidayList', icon: 'guide'}
      }, 
      {
        path: 'device/index',
        component: () => import('@/views/lift/device/list'),
        name: 'LiftDeviceList',
        menuid: 48,
        systemtypeid:1,
        meta: {title: 'DeviceList', icon: 'bug'}
      }, 
      {
        path: 'devicegroup/index',
        component: () => import('@/views/lift/devicegroup/list'),
        name: 'LiftDeviceGroupList',
        menuid: 52,
        systemtypeid: 1,
        meta: {title: 'DeviceGroupList', icon: 'peoples'}
      }, 
      {
        path: 'log',
        component: () => import('@/views/lift/keylog/list'),
        name: 'LiftKeyLogList',
        menuid: 48,
        systemtypeid: 1,
        meta: {title: 'KeyLogList', icon: 'message'}
      }, 
    ]
  }

export default componentsRouter



// WEBPACK FOOTER //
// ./src/router/modules/lift.js